import React, { useEffect, useState } from "react";
import "../SellerShippedOrders/SellerShippedOrders.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerShippedOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    axios
      .get(`${BaseUrl}${SellerServicesUrl.MyOrders}?status=all`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        setOrders(res.data.data || []);
      })
      .catch((err) => {
        console.error("API ERROR 👉", err.response?.data || err.message);
      });
  }, [token, navigate]);
const shippedOrders = orders.filter(
  (order) => order.status?.toLowerCase() === "pending"
);



  return (
    <div className="orders-page mt-5 pt-5 mb-0 mobileorders">
      <div className="container mt-5 mb-0">
        <div className="row">

          {/* ===== Tabs ===== */}
          <div className="col-lg-3 tabssection">
            <div className="orders-right-tabs">
              <button className="cright-tab "
              onClick={() => navigate("/seller/sellerconfirmedorders")}
              >
                الطلبات المؤكدة
              </button>

              <button
                className="cright-tab active"
                onClick={() => navigate("/seller/sellershippedorders")}
              >
                الطلبات المشحونة
              </button>

              <button
                className="cright-tab"
                onClick={() => navigate("/seller/sellercanceledorders")}
              >
                تم التسليم
              </button>
            </div>
          </div>

          {/* ===== Orders ===== */}
          <div className="col-lg-9 col-12">
            <div className="cards-wrapper mt-5">

              {shippedOrders.length === 0 && (
                <p className="text-center">لا توجد طلبات مشحونة</p>
              )}

              {shippedOrders.map((order) => (
                <div
                  key={order.id}
                  className="app-order-card"
                  onClick={() =>
                    navigate(
                      `/seller/sellerconfirmedordersdetails/${order.id}`
                    )
                  }
                >
                  {/* Header */}
<div className="app-order-header">
  
  <div className="left-header">
    <span className="app-status">{order.status?.toUpperCase()}</span>

    {/* <div className="total">
      <span className="label">الإجمالي</span>
      <span className="price">{order.final_total} ر.س</span>
    </div> */}
  </div>

  <span className="app-order-number">#{order.orderNumber}</span>
  <span className="app-order-number">
</span>

</div>



<div className="app-order-body">

  <div className="body-col">
    <span className="label pt-3">الإجمالي</span>
    <span className="price">{order.final_total} ر.س</span>
  </div>

  <div className="body-col center">
    <span className="label pb-2">التاريخ</span>
    <span className="value">--</span>
  </div>

  <div className="body-col">
    <span className="label">العدد</span>
    <span className="value">1</span>
  </div>

  <div className="lock-box">
    <i className="lockicon fa fa-lock"></i>
  </div>

</div>




                </div>
              ))}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
